import React from "react";
import { FaCode, FaLaptopCode, FaSitemap } from "react-icons/fa6";
import banner4 from "../assets/banner4.jpg";

export default function GeneratorServicing() {
  const features = [
    {
      icon: <FaCode size={20} className="text-primary" />,
      text: "Custom software solutions designed around operational realities and user workflows.",
    },
    {
      icon: <FaLaptopCode size={20} className="text-primary" />,
      text: "Applications that improve process control, visibility, and internal service delivery.",
    },
    {
      icon: <FaSitemap size={20} className="text-primary" />,
      text: "Digital products built with integration, maintainability, and future enhancement in mind.",
    },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">Software & Application Development</h2>
          <p className="section-copy">
            Nova Technologies develops software and applications that make work easier,
            clearer, and more scalable for modern organizations.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner4} alt="Software and Application Development" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Application development engagements focus on solving practical business
            problems, whether the need is process digitization, internal tooling, or more
            effective information handling across teams.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map((item) => (
              <li key={item.text} className="detail-feature-item">
                {item.icon}
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Clarify business goals, users, and workflow requirements.</li>
            <li>Design and build fit-for-purpose application experiences.</li>
            <li>Test, refine, and align the solution with operational needs.</li>
            <li>Support rollout, adoption, and future improvement planning.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}
